export const partners = [
  { id: 1, logo: '/partners/1-1.jpg' },
  { id: 2, logo: '/partners/2-1.jpg' },
  { id: 3, logo: '/partners/3-1.jpg' },
  { id: 4, logo: '/partners/4-1.jpg' },
  { id: 5, logo: '/partners/5-1.jpg' },
  { id: 6, logo: '/partners/6-1.jpg' },
  { id: 7, logo: '/partners/7-1.jpg' },
  { id: 8, logo: '/partners/8-1.jpg' },
  { id: 9, logo: '/partners/9-1.jpg' },
  { id: 10, logo: '/partners/10-1.jpg' },
  { id: 11, logo: '/partners/11-1.jpg' },
  { id: 12, logo: '/partners/12-1.jpg' },
  { id: 13, logo: '/partners/13-1.png' },
  { id: 14, logo: '/partners/14-1.png' },
  { id: 15, logo: '/partners/15-1.jpg' },
  { id: 16, logo: '/partners/16-1.jpg' },
  { id: 17, logo: '/partners/17-1.jpg' },
];
export const prtnrs = [
  '/prtnrs/partner_logo-0.png',
  '/prtnrs/partner_logo-1.png',
  '/prtnrs/partner_logo-2.png',
  '/prtnrs/partner_logo-3.png',
  '/prtnrs/partner_logo-4.png',
  '/prtnrs/partner_logo-4-1.jpg',
  '/prtnrs/partner_logo-5.png',
  '/prtnrs/partner_logo-6.png',
  '/prtnrs/partner_logo-7.png',
  '/prtnrs/partner_logo-11.png',
  '/prtnrs/partner_logo-12.png',
  '/prtnrs/partner_logo-10.png',
  '/prtnrs/partner_logo-8.png',
  '/prtnrs/partner_logo-9.png',
  '/prtnrs/partner_logo-13.png',
  '/prtnrs/partner_logo-14.png',
  '/prtnrs/partner_logo-15.png',
  '/prtnrs/partner_logo-16.png',
  '/prtnrs/partner_logo-17.png',
  // '/prtnrs/partner_logo-18.png',
];
